import React from "react";
import MobileUserPane from "./project_users_list";
import VillageMeetingPane from "../../pane/village_meeting";
import VLUMPRAListPane from "../../pane/vlum_pra_list";
import DataProcessingPane from "../../pane/data_processing";
import DataCollectionPane from "../../pane/data_collection";
import DocumentPane from "../../pane/document_pane";
import PlotAllocationPane from "../../pane/plot_allocation";
import FormalizationMapPane from "../../pane/formalization_map";
import DeedPlanInfoListPane from "../../pane/deedplan_info";
import PartiesAllocationPane from "../../pane/parties_allocation";
import CCROLayersMapPane from "../../pane/ccro/ccro_layes_map";
import QuestionnarePane from "../../pane/questionnaire_pane";
import CCRORejectedDataPane from "../../pane/ccro/ccro_rejected_data";
import CCROGISApprovalPane from "../../pane/ccro/ccro_gis_approval_data";
import CCROIssuedDataPane from "../../pane/ccro/ccro_issued_data";
import CCRORegisteredDataPane from "../../pane/ccro/ccro_registered_data";
import ProjectInfoPane from "./project_info";
import VillageQuestionnairesPane from "../../pane/vlus/vlus_questionnaire_pane";
import CCROSignatoriesPane from "./signatories_list";
import MapLandUse from "../nluis_spatial/map_landuse";
import LocalityInfoPane from "../../pane/locality_info_pane";
import FormalizationInputMap from "../nluis_spatial/formalization_deedplan";
import QuestionnairePane from "../../pane/questionnaire_pane";
import MNEPane from "../../pane/mne_pane";
import CcroDraftDataPane from "../../pane/ccro/ccro_draft_data_pane";
import DownloadPane from "../../pane/download_pane";


export default class ProjectScreen {

    static getScreenByCode(code,project,taskId,taskCode) {
        console.log('getScreenByCode called with:', { code, project, taskId, taskCode });
        switch (code) {

            case 'project_info':
                return <ProjectInfoPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} task_code={taskCode}/>
            case 'project_team':
                return <MobileUserPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} task_code={taskCode}/>
            case 'project_documents':
                return <DocumentPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} task_code={taskCode}/>
            case 'project_map':
                return <MapLandUse key={new Date().getMilliseconds()} project={project} screen_code={code} villageId={234}  taskId={taskId}/>
            case 'ccro_signatories':
                return <CCROSignatoriesPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'questionnaires':
                return <VillageQuestionnairesPane key={new Date().getMilliseconds()} village={1} project={project} screen_code={code} taskId={taskId}/>
            case 'mobile_users':
                return <MobileUserPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'village_meeting':
                return <VillageMeetingPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'vlum_registration':
                return <VLUMPRAListPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'data_collection':
                return <DataCollectionPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'data_processing':
                return <DataProcessingPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'document_pane':
                return <DocumentPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'plot_allocation':
                return <PlotAllocationPane status={'vacant'} key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'allocated_plots':
                return <PlotAllocationPane status={'occupied'} key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>

            case 'formalization_map':
                return <FormalizationMapPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'deedplan_info':
                return <DeedPlanInfoListPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'parties':
                return <PartiesAllocationPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'project_layers':
                return <CCROLayersMapPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'formalization_deed_plan_map':
                return <FormalizationInputMap key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'locality_info':
                return <LocalityInfoPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'parcel_info'}/>
            case 'ccro_draft_data':
                return <CcroDraftDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'parcel_info'}/>
            case 'ccro_rejected_data':
                return <CCRORejectedDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'ccro_gis_approved_data':
                return <CCROGISApprovalPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'ccro_registered_data':
                return <CCRORegisteredDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} stage={'registered'}/>
            case 'ccro_printed':
                return <CCRORegisteredDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} stage={'printed'}/>
            case 'ccro_general_report':
                return <CCROIssuedDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'ccro_issued_data':
                console.log('Loading CCROIssuedDataPane for ccro_issued_data screen code with generate report task');
                return <CCROIssuedDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'issued_ccros':
                console.log('Loading CCROIssuedDataPane for issued_ccros screen code');
                return <CCROIssuedDataPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>
            case 'project_preliminary_info':
                return <QuestionnarePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'preliminary_info'}/>
            case 'project_house_hold':
                return <QuestionnarePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'house_hold'}/>
            case 'project_focus_group':
                return <QuestionnarePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'focused_group'}/>
            case 'project_key_info':
                return <QuestionnarePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'key_informants'}/>
            case 'project_multmedia':
                return <QuestionnarePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'multimedia'}/>
            case 'dodosos':
                return <QuestionnairePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'table'}/>
            case 'data_analysis':
                return <QuestionnairePane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'analyse'}/>
            case 'mne_verification':
                return <MNEPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId} flag={'verification'}/>
            case 'download_screen':
                return <DownloadPane key={new Date().getMilliseconds()} project={project} screen_code={code} taskId={taskId}/>

        }
        console.log('No matching case found for code:', code);
        return code;
    }

}
